import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { DocumentCollectionOperations } from "../../../api/types/documentCollectionTypes";

export interface Props {
  hasPermissionsToManage: boolean;
  onDownloadDocumentCollection: (id: string) => void;
  onChangeDocumentCollectionsStatus: (ids: string[], operation: DocumentCollectionOperations) => void;
}

export const DocumentCollectionsPageContext = createContext<Props | undefined>(undefined);

export const useDocumentCollectionsPageContext = () =>
  defined(use(DocumentCollectionsPageContext), "Attempt to use DocumentCollectionsPageContext without provider");
